import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../../context/themeContext";
import { Close, Favorite, FavoriteBorderOutlined } from "@mui/icons-material";
import ConfettiButton from "../../../../../../../components/common/Confetti";
import { useRef } from "react";
import useDiscover from "../../../../../../../hooks/useDiscover";

function Top({
  name,
  image,
  project,
  isFavorite,
  setIsFavorite,
  removeFav,
  AddFav,
  showConfetti,
  setShowConfetti,
}) {
  const { theme } = useTheme();
  const { handleCloseProject } = useDiscover(true);
  const containerRef = useRef(null);

  const handleShoutOutClick = async () => {
    if (isFavorite) {
      cancelShoutOut();
      return;
    }
    AddFav();
  };

  const cancelShoutOut = async () => {
    removeFav();
  };

  return (
    <Box className={styles.top}>
      <Box className={styles.profile}>
        <Box
          className={styles.image}
          sx={{
            backgroundImage: `url(${image})`,
            width: "48px",
            height: "48px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        ></Box>
        <Box className={styles.name}>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.darkgrey.darkgrey600,
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              WebkitLineClamp: 1,
              textOverflow: "ellipsis",
            }}
          >
            {name}
          </Typography>
        </Box>
        <Box
          className={styles.options}
          sx={{
            "& .css-ixzp6w-MuiChip-root": {
              height: "auto",
            },
          }}
        >
          <Box
            ref={containerRef}
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <ConfettiButton
              showConfetti={showConfetti}
              setShowConfetti={setShowConfetti}
              containerRef={containerRef}
            />
            {isFavorite ? (
              <Favorite
                sx={{ fill: theme.palette.primary.main }}
                onClick={handleShoutOutClick}
              />
            ) : (
              <FavoriteBorderOutlined
                sx={{ fill: theme.palette.primary.main }}
                onClick={handleShoutOutClick}
              />
            )}
          </Box>
          <Close
            onClick={() => handleCloseProject(project)}
            sx={{
              color: theme.palette.darkgrey.darkgrey400,
              cursor: "pointer",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default Top;
